<mat-sidenav-container class="example-container w-100" autosize="true">
  <mat-sidenav #sidenav mode="side" opened="true" *ngIf="isExpanded || !isShowing" class="example-sidenav"
    fixedInViewport="true">


    <div class="sidenavLogoContainer">
      <div class="LogoContainer">
        <img src="assets/images/AICTELogo.png" alt="Logo" class="logoImg" *ngIf="!isShowing" style="margin: 0 20px 0 -5px !important"/>
        <img src="assets/images/SLALogo.png" alt="Logo" class="logoImg" *ngIf="!isShowing" style="width: 100px; margin: 0 20px 0 0 !important;"/>
        <img src="assets/images/Parakhlogo.png" alt="Logo" class="logoImg" *ngIf="!isShowing" style="height: 47px; width: 100px; margin: 0 0 0 -5px !important;">
      </div>
    </div>

    <mat-nav-list>
      <mat-list-item>
        <span class="full-width" *ngIf="isExpanded" (click)="menuToggle('Home')">Home</span>
        <mat-icon mat-list-icon>home</mat-icon>
      </mat-list-item>
      <mat-list-item [ngClass]="{'menu-active': dashboardMenu=='Institute'}">
        <span class="full-width" *ngIf="isExpanded" (click)="menuToggle('Institute')">Institute Dashboard</span>
        <mat-icon mat-list-icon>dashboard</mat-icon>
      </mat-list-item>
      <mat-list-item [ngClass]="{'menu-active': dashboardMenu=='Student'}">
        <span class="full-width" *ngIf="isExpanded" (click)="menuToggle('Student')">Student Assessments</span>
        <mat-icon mat-list-icon>dashboard</mat-icon>
      </mat-list-item>
      <mat-list-item [ngClass]="{'menu-active': dashboardMenu=='Gap'}">
        <span class="full-width" *ngIf="isExpanded" (click)="menuToggle('Gap')">Gap Analysis</span>
        <mat-icon mat-list-icon>dashboard</mat-icon>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <div class="example-sidenav-content">
    <mat-toolbar color="primary" class="example-toolbar">
      <div class="top-nav-start">
        <button mat-icon-button (click)="sidenav.toggle() && isShowing = !isShowing">
          <mat-icon>menu</mat-icon>
        </button>
        <div class="LogoContainer" *ngIf="isShowing">
          <img src="assets/images/AICTELogo.png" alt="Logo" class="logoImg" />
          <img src="assets/images/SLALogo.png" alt="Logo" class="logoImg" />
          <img src="assets/images/Parakhlogo.png" alt="Logo" class="logoImg" style="height: 47px;" >
        </div>
      </div>


    </mat-toolbar>

    <app-institute-dashboard-details class="menuConetntContainer" *ngIf="dashboardMenu==='Institute'"
      [ngClass]="{'activeMenu': dashboardMenu==='Institute'}"></app-institute-dashboard-details>
    <app-student-assessment-details *ngIf="dashboardMenu==='Student'" class="menuConetntContainer" [ngClass]="{'activeMenu': dashboardMenu==='Student'}">
    </app-student-assessment-details>
    <app-gap-analysis-dashboard *ngIf="dashboardMenu==='Gap'" class="menuConetntContainer" [ngClass]="{'activeMenu': dashboardMenu==='Gap'}">
    </app-gap-analysis-dashboard>

    <div class="clearfix"></div>
  </div>
  <div>
    <router-outlet></router-outlet>
    <div class="newsMarquee_Section nopad">
      <div class="marquee_Container">
        <p class="marqueeText">
          <marquee direction="left">
            <span *ngFor="let m of messages">• {{m?.body}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </marquee>
        </p>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</mat-sidenav-container>
